<template>
<DynamicPage v-if="activeObject" :objet="activeObject" :name="name" :desc="desc" :validate="validationError" @action="Act"/>
</template>
   
<script>
import DynamicPage from './DynamicPage.vue'

export default {
  name: 'NewTeam',
  components:{
    DynamicPage
  },
  emits:['refr'],
  props:{
    id: null
  },
  data:function(){
    return{
      path:{
        name:"NewTeam", 
        path: "/portaal/GetEmptyTeam",
        pathSet: "/portaal/AddTeam",
        validation: function(obj){
          if(obj != null)
            return null;
        },
      },
      validationError:"",
      name:"Maak nieuw Teamleed aan.",
      desc:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."
    }
  },
  computed:{
    activeObject(){
      return this.$store.state.dynamicStore[this.path.path];
    }
  },
  methods:{
    async Act(retour){
      const pathSet = this.path.pathSet;
      retour.orgId = this.id;
      await this.$store.dispatch('dynamicStore/setDynamic', {pathSet, retour});
      this.$emit('refr');
    }
  },
  async created(){
    await this.$store.dispatch('dynamicStore/getDynamic', this.path.path);
  }
}
</script>   

<style>

</style>